<template>
    <div class="gallery">
      <div class="grid">
        <img 
          v-for="(src, index) in photos" 
          :key="index"
          :src="src"
          :alt="`Photo ${index + 1}`"
          class="photo"
        />
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  export default defineComponent({
    name: 'DisCiple2',
    setup() {

      const photos = [
        // '/images/disciples/1.jpg',
        // '/images/disciples/2.jpg',
        // '/images/disciples/3.jpg',
        // '/images/disciples/4.jpg',
        // '/images/disciples/5.jpg',
        // '/images/disciples/6.jpg',
        // '/images/disciples/7.jpg',
        // '/images/disciples/8.jpg',
        // '/images/disciples/9.jpg',
        // '/images/disciples/10.jpg',
        // '/images/disciples/11.jpg',
        // '/images/disciples/12.jpg',
      ];
  
      return { photos };
    },
  });
  </script>
  
  <style scoped>
  .gallery {
    padding: 1rem;
    background: #f9fafb;
  }
  
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.75rem;
  }
  
  @media (min-width: 768px) {
    .grid {
      grid-template-columns: repeat(4, 1fr);
      gap: 1rem;
    }
  }
  
  .photo {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 8px;
    display: block;
  }
  </style>